module.exports = __webpack_public_path__ + "static/media/Avatar2.dc881b13.svg";